import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'convfact-preinvoicetabs',
    templateUrl: './preinvoicetabs.component.html',
    styleUrls: ['./preinvoice.component.css'],
    standalone: false
})
export class PreinvoiceTabsComponent {

  routeLinks: any[];
  activeLinkIndex = 0;
  constructor(private router: Router) {
    this.routeLinks = [
      { label: 'Pendientes', link: 'pending' },
      { label: 'Publicados', link: 'published' }
    ];

  }
  public trackByIndex(i: number) { return i; }

}
